const getReferrerFrom = (): { from?: string } => {
  const storedRef = sessionStorage.getItem('initialReferrer');

  if (!storedRef) return {};

  return { from: storedRef };
};

export default getReferrerFrom;
